import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useRouter } from 'next/router'

import { Navigation } from "@layouts/NavigationV2"
import Plans from './Plans'
import { Reviews } from "./reviews"
import { FeaturesTable } from "./featuresTable"
import { BannerSecurity } from "./bannerSecurity"
import { Faq } from "./faq"
import CTABanner from "./CTABanner"
import PaymentPlanAtom from '@components/Pricing/atoms/Plan'
import { useAtomValue } from 'jotai'
import { PAYMENT_PLANS } from "./paymentPlansData"

const PricingPageB = () => {
  const router = useRouter();

  const paymentPlanAtom = useAtomValue(PaymentPlanAtom)

  const paymentPlan = useMemo(() => {
    return PAYMENT_PLANS.filter(item => item.name === (paymentPlanAtom as any))[0] || undefined
  }, [paymentPlanAtom])

  useEffect(() => {
    const chatBtn = document.getElementById('sm-widget-launcher-btn');
    if (chatBtn) {
      chatBtn.style.display = router.pathname === '/pricing' ? 'block' : 'none';
    }
  }, [router.pathname]);

  return (
    <>
      <Navigation
        staticTheme="dark"
        actionTheme="dark"
      />

      <Plans paymentPlan={paymentPlan} />

      <Reviews />

      <FeaturesTable paymentPlan={paymentPlan} />

      {/* <BannerSecurity /> */}

      <Faq />

      <CTABanner
        title="Try any paid plan free for 14 days"
        btnText="Create workspace"
      />

    </>
  );
};

export default PricingPageB;
